// extracted by mini-css-extract-plugin
module.exports = {"data_collected":"datacollection_data_collected__221O2","qa_ans":"datacollection_qa_ans__2-5Qj","qa":"datacollection_qa__1EntW"};